import React, { Component } from "react";

import Loader from "../../../../../../settings/loader";

import commaNumber from "comma-number";

import "./style.scss";

export default class Slider2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        result: null,
        table: [],
      },
      height: 400,
      load: 0,
    };
  }

  _initialized() {
    if (this.props.data && !this.state.load) {
      this.setState((prevstate) => ({
        data: {
          ...prevstate.data,
          result: this.props.data,
        },
        load: 1,
      }));
    }
  }

  topParser(tableData) {
    let qtyArray = [];

    tableData.forEach((data, index) => {
      qtyArray.push(data.total);
    });

    return {
      max: Math.max(...qtyArray),
      ave: qtyArray[Math.floor((qtyArray.length - 1) / 2)],
      min: Math.min(...qtyArray),
    };
  }

  loadData() {
    if (this.state.load) {
      const revcent = this.state.data.result.revCent.data.map((data) => ({
        ...data,
        total: 0,
      }));

      this.state.data.result.sales.data.forEach((data, index) => {
        const queryRevcent = revcent.find((rev) => rev.name === data.revCent);

        if (queryRevcent) {
          queryRevcent.total += data.total;
        }
      });

      this.setState((prevState) => ({
        data: {
          ...prevState.data,
          table: revcent.filter((data) => data.total).sort(this.sortSales),
        },
        load: 2,
      }));
    }
  }

  sortSales(a, b) {
    if (parseInt(a.total) > parseInt(b.total)) {
      return -1;
    }

    if (parseInt(a.total) < parseInt(b.total)) {
      return 1;
    }

    return 0;
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.export !== this.props.export) {
      this.props.getData({
        type: "table",
        title: "Weekly - Revenue Center",
        body: {
          head: [],
          body: [],
        },
      });
    }
  };

  render() {
    switch (this.state.load) {
      case 0:
        this._initialized();
        break;
      case 1:
        this.loadData();
        break;
      default:
        break;
    }

    return (
      <div id={"exportPdf_Slide2"}>
        {!this.state.load ? (
          <Loader />
        ) : (
          <table
            className={["table", "table-striped", "defaultTable"].join(" ")}
          >
            <thead>
              <tr>
                <th scope={"col"}>Revenue Center</th>
                <th scope={"col"}>Total</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.table.map((data, key) => (
                <tr key={key}>
                  <td>
                    {String(data.name)
                      .toLowerCase()
                      .split(/(?: - )|(?:-)/)
                      .map((string) =>
                        string
                          .split(/ /)
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.substring(1)
                          )
                          .join(" ")
                      )
                      .join(" ")}
                  </td>
                  <td>
                    {this.props.fields.currency.base}{" "}
                    {commaNumber(data.total.toFixed(2))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}
